import * as React from 'react';
import { Link } from 'react-router';

/**
 * This component is displayed when the app is at an unknown route.
 */
export const ErrorPage: React.FC = (): JSX.Element => (
  <div className="page">
    <h1>Page not found</h1>
    <p>
      You may be trying to view a tenant that no longer exists. If you believe
      there is a problem with this service, please contact your administrator.
    </p>
    <Link className="btn btn-primary" to="/">
      <span className="oi oi-home" />
      Go to homepage
    </Link>
  </div>
);
